import React, { useEffect, useState } from 'react';

import Axios from './hooks/Axios';
import Store from './hooks/Store';
import SessionId from './hooks/SessionId';
import Configuration from './hooks/Configuration';
import Chatbot from './components/molecules/Chatbot';

let timer: ReturnType<typeof setInterval>;

function App() {
    const stxChatbot = (window as any).stxChatbot;
    console.log('CHATBOT start');
    const [apiKey, setApiKey] = useState(stxChatbot.api_key);

    //pokud se zmeni api_key, tak se prenacte cely chatbot
    useEffect(
        () => {
            timer = setInterval(() => setApiKey(stxChatbot.api_key), 1000);
            return () => clearInterval(timer);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <Store>
            <SessionId>
                <Axios key={apiKey}>
                    <Configuration>
                        <Chatbot />
                    </Configuration>
                </Axios>
            </SessionId>
        </Store>
    );
}

export default App;
